/**
 * Map Layout Constants
 *
 * Centralized constants for map layout configuration
 * following Clean Architecture principles
 */

export const MAP_LAYOUT = {
  // Details Panel Dimensions
  DETAILS_PANEL_WIDTH: {
    MOBILE: 'w-full',
    DESKTOP: 'lg:w-[400px]'
  },
  DETAILS_PANEL_MIN_HEIGHT: {
    MOBILE: 'min-h-[400px]',
    DESKTOP: 'lg:min-h-full'
  },

  // Transition Durations
  TRANSITION_DURATION: 300,

  // Animation Classes
  TRANSITION_CLASSES: 'transition-all duration-300 ease-in-out'
} as const;


